import React from 'react'

const AvatarView = (props) => {

    return (
        <img
            width={props.width}
            height={props.height}
            src={props.value}
            alt={''}
        />
    )
}

export default AvatarView